import Rails from "@rails/ujs";

import currentLocale from "shared/currentLocale";

export default ({ id, formSelections, success, error }) => {
  let url = `/${currentLocale()}/frontoffice/api/bookings/${id}/preview_price`;

  if (formSelections) {
    let queryString = "";

    if (formSelections instanceof URLSearchParams) {
      queryString = formSelections.toString();
    } else {
      const queryParams = new URLSearchParams();
      Object.entries(formSelections).forEach(([key, value]) => {
        queryParams.append(key, value);
      });
      queryString = queryParams.toString();
    }

    if (queryString) {
      url += `?${queryString}`;
    }
  }

  Rails.ajax({
    type: "GET",
    dataType: "json",
    url,
    success,
    error,
  });
};
